import { ActivityIndicator, Dimensions, Modal, PixelRatio, ScrollView, StyleSheet, Text, TouchableOpacity, View } from 'react-native'
import React, { useEffect, useRef, useState } from 'react'
import MoneyIcon from '../../icons/MoneyIcon'
import Colours from '../../utils/Colours'
import VisaCardIcon from '../../icons/VisaCardIcon'
import TransferFromTable from './TransferFromTable'
import TopHeaderComponent from '../aTopHeader/TopHeaderComponent'
import PurchaseFromTable from './PurchaseFromTable'
import useAuth from '../../hooks/useAuth'
import ErrorAlertComp from '../../alertComp/ErrorAlertComp'
import CalenderSignUpScreenModal from '../signInScreen/CalenderSignUpScreenModal'
import useAxiosPrivate from '../../hooks/useAxiosPrivate'
import SuccessAlertComp from '../../alertComp/SuccessAlertComp'

const { width, height } = Dimensions.get('window');
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

// Function to adjust font size
const dynamicFontSize = (size) => {
    const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
    const newSize = size * scaleFactor;

    return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const TopUpSmallAmounts = ({ hideModal, tableDataToUse }) => {
    const [isButtonClicked, setIsButtonClicked] = useState(false)
    const [showErrorAlert, setShowErrorAlert] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [successMessage, setSuccessMessage] = useState('')
    const [isSuccessCompVisible, setIsSuccessCompVisible] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    // const [showTransferFromTable, setShowTransferFromTable] = useState(false)

    const [activePattern, setActivePattern] = useState('')

    // const { activitySettings } = useAuth()

    const axiosPrivate = useAxiosPrivate();







    useEffect(() => {
        //console.log('tableDataToUse', tableDataToUse)
    }, [])


    const saveDateToDB = async (topUpValue) => {
        try {
            // send to backend
            setIsLoading(true)
            const response = await axiosPrivate.post('/smallTopUp/smallTopUp', {
                amount: topUpValue,
                tableID: tableDataToUse?._id
            });

            //console.log('Saved data:', response.data);

            // success flow
            if (response.status === 200 || response.status === 201) {
                setSuccessMessage(response.data.message || "Top-up successful!");
                setIsSuccessCompVisible(true);
            } else {
                setErrorMessage(response.data.message || "Something went wrong");
                setIsErrorCompVisible(true);
            }
        } catch (err) {
            //console.error("Top-up error:", err);

            // check if backend sent message
            if (err.response && err.response.data && err.response.data.message) {
                setErrorMessage(err.response.data.message);
            } else {
                setErrorMessage("An error occurred while topping up");
            }
            setIsErrorCompVisible(true);
        } finally {
            setIsLoading(false);
        }
    }

    const handleSpendPattern = (pattern) => {
        setActivePattern(pattern)
    }


    const handleChoose = async () => {
        //setIsButtonClicked(true)
        //console.log('activePattern', activePattern)
        if (activePattern === 'five') {
            //console.log('pattern', activePattern)
            //  setSelectedDateData('five')
            await saveDateToDB(500);


        } else if (activePattern === 'one') {
            //console.log('pattern', activePattern)
            //  setSelectedDateData('one')
            await saveDateToDB(1000);

        } else {
            //console.log('Please select an active pattern')
        }
        //   hideScreen()
    }

    return (
        <View>
            <View style={styles.paymentMethodStyle}>
                <Text style={styles.useCaptionTxt}>Choose the amount you would like to top up. For larger amounts, please create a new table.</Text>

            </View>

            <View style={styles.paymentMethodStyle}>

                <TouchableOpacity style={[
                    styles.dataContainer2,
                    { borderColor: activePattern === 'five' ? Colours.PRIMARY : Colours.LIGHTGRAY },
                ]}
                    onPress={() => handleSpendPattern('five')}
                >
                    <View style={styles.dataSubContainer}>
                        <View style={styles.captionAndDescribtion}>
                            <View style={styles.flatArrowContainer}>
                                <Text style={{ color: activePattern === 'five' ? Colours.PRIMARY : Colours.DARKLIGHTGRAY, fontSize: dynamicFontSize(14), fontFamily: 'Sen-Regular' }}>500</Text>

                            </View>
                        </View>
                    </View>
                </TouchableOpacity>

                <TouchableOpacity style={[
                    styles.dataContainer2,
                    { borderColor: activePattern === 'one' ? Colours.PRIMARY : Colours.LIGHTGRAY },
                ]}
                    onPress={() => handleSpendPattern('one')}
                >
                    <View style={styles.dataSubContainer}>
                        <View style={styles.captionAndDescribtion}>
                            <View style={styles.flatArrowContainer}>
                                <Text style={{ color: activePattern === 'one' ? Colours.PRIMARY : Colours.DARKLIGHTGRAY, fontSize: dynamicFontSize(14), fontFamily: 'Sen-Regular' }}>1000</Text>
                            </View>
                        </View>
                    </View>
                </TouchableOpacity>


                <TouchableOpacity style={[styles.buttonGray,
                { backgroundColor: isButtonClicked ? Colours.PRIMARY : Colours.LIGHTGRAY }]}
                    onPress={() => handleChoose()}
                    disabled={isLoading}
                >

                    {isLoading ? (
                        <ActivityIndicator color={Colours.PRIMARY} size={'small'} />
                    ) : (
                        <Text style={styles.proceedTxt}>Proceed</Text>
                    )}
                </TouchableOpacity>

            </View>


            <Modal
                visible={showErrorAlert}
                animationType='fade'
                transparent={true}

            >
                <ErrorAlertComp
                    message={errorMessage}
                    onClose={() => {

                        setShowErrorAlert(false)
                    }}
                />
            </Modal>
            <Modal
                visible={isSuccessCompVisible}
                transparent={true}
                animationType="fade"
            >
                <SuccessAlertComp
                    message={successMessage}
                    onClose={() => {
                        setIsSuccessCompVisible(false)
                        hideModal(true)
                    }}
                />
            </Modal>

        </View>
    )
}


const styles = StyleSheet.create({
    paymentMethodStyle: {
        display: 'flex',
        justifyContent: 'center',
        margin: dynamicSpacing(15),
        marginBottom: dynamicSpacing(4),
        padding: dynamicSpacing(15),
        borderRadius: dynamicSize(15),
        backgroundColor: 'white',
        shadowColor: '#E8E8E8'
    },
    useCaptionTxt: {
        marginBottom: dynamicSpacing(10),
        color: Colours.DARKGRAY,
        fontSize: dynamicFontSize(15),
        fontFamily: 'Sen-Bold'
    },
    moneyOnTableTxt: {
        color: Colours.DARKGRAY,
        fontSize: dynamicFontSize(14),
        fontFamily: 'Sen-Regular'
    },
    moneyAmtTxt: {
        color: Colours.PRIMARY,
        fontSize: dynamicFontSize(15),
        fontFamily: 'Sen-Bold'
    },
    proceedTxt: {
        color: Colours.DARKGRAY,
        fontSize: dynamicFontSize(17),
        fontFamily: 'Sen-Bold'
    },
    dataContainer2: {
        display: 'flex',
        borderWidth: 1,
        borderColor: Colours.PRIMARY_LIGHTER,
        padding: dynamicSpacing(15),
        borderRadius: dynamicSize(10),
        marginBottom: dynamicSpacing(10),
    },
    dataContainer: {
        display: 'flex',
        backgroundColor: 'white',
        margin: dynamicSpacing(10),
        marginTop: dynamicSpacing(15),
        padding: dynamicSpacing(15),
        borderRadius: dynamicSize(10),
        marginBottom: dynamicSpacing(10),
    },
    dataSubContainer2: {
        display: 'flex',
        flexDirection: 'row',
        gap: dynamicSpacing(10),
        alignItems: 'center',
        marginBottom: dynamicSpacing(10)
    },
    dataSubContainer: {
        display: 'flex',
        flexDirection: 'row',
        gap: dynamicSpacing(10),
        alignItems: 'center'
    },
    flatArrowContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    captionAndDescribtion: {
        display: 'flex',
    },
    buttonGray: {
        display: 'flex',
        borderRadius: dynamicSize(10),
        justifyContent: 'center',
        marginTop: dynamicSpacing(10),
        alignItems: 'center',
        height: dynamicSize(55),
        width: '100%',
        backgroundColor: Colours.DARKGRAY,
    },
});

export default TopUpSmallAmounts
